import { useTranslation } from 'react-i18next';
import { onClickOpenReferenceMaterial } from 'core/utils/referenceMaterial';
import type { AttachmentContent } from 'app/types/attachment';

type UseMaterialPreviewStudentSidebarProps = {
  referenceMaterial?: AttachmentContent | null;
  attachedFiles?: { name: string; size: number; type: string; url: string }[];
};

type UseMaterialPreviewStudentSidebarReturn = {
  t: (key: string, options?: Record<string, unknown>) => string;
  hasAttachments: boolean;
  handleShowVisor: () => void;
};

function useMaterialPreviewStudentSidebar({
  referenceMaterial,
  attachedFiles = [],
}: UseMaterialPreviewStudentSidebarProps): UseMaterialPreviewStudentSidebarReturn {
  const { t } = useTranslation(['actions', 'common']);

  const hasAttachments = !!(referenceMaterial || attachedFiles.length > 0);

  function handleShowVisor() {
    if (referenceMaterial) onClickOpenReferenceMaterial(referenceMaterial);
  }

  return { t, hasAttachments, handleShowVisor };
}

export default useMaterialPreviewStudentSidebar;
